var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"section"},[(_vm.status != 'SIGNED')?_c('b-progress',{attrs:{"type":_vm.progressType}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }